import Utils from "@solimat/solimat-web-endpoint/lib/utils"
import { ICnaeResponse } from "@solimat/solimat-web-endpoint/lib/utils/dto";
import { getFechaCNAE, watchFechaCNAE } from "./fechaCNAEUtils";

const useGetAllCnaeCompany= () => {

  const BASE_URL = import.meta.env.VITE_REACT_APP_MAESTROS_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_MAESTROS_KEY || "";

  const apiUtils = new Utils.UtilsService(BASE_URL, FUNCTIONS_KEY);

  const getAllCnaeCompany = async (fechaBaja?: string) => {
    const fecha = fechaBaja ?? getFechaCNAE();
    try {
      const res = await apiUtils.getAllCnaeCompany(fecha);
      return res.data as ICnaeResponse[] | undefined;
    } catch (err) {
      console.error("getAllCnaeCompany", err);
    }

  }

  return {
    getAllCnaeCompany,
    watchFechaCNAE
  }

}

export default useGetAllCnaeCompany;